module.exports = __webpack_public_path__ + "static/img/分类图片3@3x.12bbb07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/分类图片3@3x.png
// module id = +Fvf
// module chunks = 192